import React from "react";
import {observer} from "mobx-react";
import {AgencyPage} from "../agency.page";
import styled from "styled-components";
import {BookingSearchResultsComponent} from "./booking-search-results.component";
import {useScreenMediaQueriesChecks} from "../../../hooks/use-screen-media-queries-checks.hook";
import {
    BookingSearchFiltersAsSideMenuComponent
} from "./booking-search-filters-as-side-menu.component";
import {useServices} from "../../../hooks/use-services.hook";
import { BookingSearchFiltersComponent } from "./booking-search-filters.component";


const PAGE_ROOT_CONTENT_CSS_CLASS = "agency-booking-search-page-content";

const AgencyPageBox = styled(AgencyPage)`
    & .${PAGE_ROOT_CONTENT_CSS_CLASS} {
        overflow: hidden;
    }
`

const BookingSearchPageContentBox = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    gap: ${props => props.theme.spacing.flexGap20};
    padding-bottom: ${props => props.theme.spacing.spacing20};
    ${props => props.theme.screenMediaQuery.smallScreen} {
        flex-direction: column;
    }
`


export const AgencyBookingSearchPage: React.FC = observer(() => {
    const services = useServices()
    const screenMediaQuery = useScreenMediaQueriesChecks();
    const sideMenuController = services.sideMenu.agencyBookingSearchSideMenuController;

    const renderSearchPanelForSmallScreen = () => {
        if(screenMediaQuery.smallScreen) {
            return (<BookingSearchFiltersAsSideMenuComponent/>);
        }


        return null;
    }

    const renderSearchFiltersForLargeScreen = () => {
        if(screenMediaQuery.smallScreen) {
            return null;
        }

        return (
            <BookingSearchFiltersComponent/>
        );
    }



    return (
        <AgencyPageBox content={{
            contentCssClass: PAGE_ROOT_CONTENT_CSS_CLASS,
            reducePaddingTopOnScroll: true
        }}>
            {renderSearchPanelForSmallScreen()}
            <BookingSearchPageContentBox id={sideMenuController.contentId} >
                {renderSearchFiltersForLargeScreen()}
                <BookingSearchResultsComponent/>
            </BookingSearchPageContentBox>
        </AgencyPageBox>
    );
})